interface CategoryCardProps {
  name: string
  description: string
  image: string
  onClick?: () => void
}

export default function CategoryCard({ name, description, image, onClick }: CategoryCardProps) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex flex-col sm:flex-row gap-4 w-full">
      
      {/* Imagen */}
      <div className="w-full sm:w-40 h-40 sm:h-28 rounded-xl overflow-hidden flex-shrink-0">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Contenido */}
      <div className="flex flex-col justify-between flex-1">
        
        <div>
          <h3 className="text-lg font-semibold text-gray-800">
            {name}
          </h3>

          <p className="text-sm text-gray-600 mt-1 line-clamp-2">
            {description}
          </p>
        </div>

        <button
          onClick={onClick}
          className="mt-3 inline-flex items-center gap-2 text-teal-700 font-medium hover:underline self-start sm:self-auto"
        >
          Ir a la categoría →
        </button>
      </div>

    </div>
  )
}
